import React, { useLayoutEffect } from "react";
import * as Yup from "yup";
import { useFormik } from "formik";
import $ from "jquery";
import { useState } from "react";
import { useContext } from "react";
import { cartContext } from "../../Context/CartContext";
import axios from "axios";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import PaymentIcon from "@mui/icons-material/Payment";
import { Helmet } from "react-helmet";
import { useNavigate } from "react-router-dom";

export default function Payment() {
  const baseURL = "https://ecommerce.routemisr.com"; // or 'https://route-ecommerce-app.vercel.app'
  const navigate = useNavigate();
  const { cartId, setcartData } = useContext(cartContext);
  const [loadingAddress, setloadingAddress] = useState(false);
  const [shippingAddress, setshippingAddress] = useState(null);
  const [flag, setflag] = useState(false);

  let token = {
    token: localStorage.token,
  };

  async function getDefultAddress(id) {
    try {
      let data = await axios.get(`${baseURL}/api/v1/addresses/${id}`, {
        headers: token,
      });
      if (data.data.data !== null) {
        setshippingAddress({
          details: data.data.data.details,
          phone: data.data.data.phone,
          city: data.data.data.city,
        });
        setflag(true);
      }
    } catch (error) {
      console.log(error);
    }
  }

  // Validate Address:
  let validationAddress = Yup.object({
    details: Yup.string()
      .required("Address Details is Required")
      .min(5, "Details minlength is 3 chars")
      .max(35, "Details maxlength is 10 chars"),
    city: Yup.string()
      .required("City is Required")
      .min(3, "City minlength is 3 chars")
      .max(10, "City maxlength is 10 chars"),
    phone: Yup.string()
      .required("Phone is required")
      .matches(/^01[0125][0-9]{8}$/, "Phone must be valid Eg-number"),
  });

  //  Get pinned Address
  function getAddress() {
    setloadingAddress(true);
    setshippingAddress({
      details: $("#details").val(),
      phone: $("#phoneA").val(),
      city: $("#city").val(),
    });
    $(".formAddress").slideUp(200);
    $("#change").fadeIn(200);
    setloadingAddress(false);
    setflag(true);
  }
  let formikAddress = useFormik({
    initialValues: {
      details: "",
      phone: "",
      city: "",
    },
    validationSchema: validationAddress,
    onSubmit: getAddress,
  });

  // Funtion to open Address Form
  function openForm(form, btnId) {
    $(`.${form}`).slideDown(200);
    $(`#${btnId}`).fadeOut(100);
  }

  // Function to close Address Form
  function closeChangeForm(form, btnId) {
    $(`.${form}`).slideUp(200);
    $(`#${btnId}`).fadeIn(100);
  }

  // Function to call Api for cash payment
  async function payCash() {
    try {
      let data = await axios.post(
        `${baseURL}/api/v1/orders/${cartId}`,
        {
          shippingAddress: {
            details: shippingAddress.details,
            phone: shippingAddress.phone,
            city: shippingAddress.city,
          },
        },
        {
          headers: token,
        }
      );
      if (data.data.status === "success") {
        setcartData(null);
        navigate("/allorders");
      }
    } catch (error) {}
  }

  // Function to call Api for online payment
  async function payOnline() {
    try {
      let data = await axios.post(
        `${baseURL}/api/v1/orders/checkout-session/${cartId}?url=http://localhost:3000`,
        {
          shippingAddress: {
            details: shippingAddress.details,
            phone: shippingAddress.phone,
            city: shippingAddress.city,
          },
        },
        {
          headers: token,
        }
      );
      if (data.status === 200) {
        window.open(data.data.session.url);
      }
      console.log(data);
    } catch (error) {}
  }

  useLayoutEffect(() => {
    if (
      localStorage.getItem("addresses") !== null &&
      shippingAddress === null
    ) {
      let id = localStorage.addresses;
      getDefultAddress(id);
    }
  }, []);

  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Payment</title>
      </Helmet>
      <div className="py-4 px-2 my-3">
        <div>
          <div className="address d-flex justify-content-between align-items-center">
            <h2 className="text-main h4 mb-4">1- Shipping Address:</h2>

            {/* check if  shipping Address display it if not display form to enter shipping Address  */}
            {shippingAddress ? (
              // if shipping Address true => display change button
              <button
                id="change"
                className="btn Btn"
                onClick={() => openForm("formAddress", "change")}
              >
                Change
              </button>
            ) : (
              ""
            )}
          </div>
          {shippingAddress ? (
            <p className="m-1">
              <span className="text-main mb-3">Address Details:</span>
              {shippingAddress.details} <br />{" "}
              <span className="text-main">City:</span> {shippingAddress.city}{" "}
              <span className="text-main">Phone:</span> {shippingAddress.phone}{" "}
            </p>
          ) : (
            <div className="row shadow-lg rounded-bottom w-100 mx-auto py-3 pb-4 align-items-center formAddress">
              <h2 className="text-main h4 mb-2">Add Address:</h2>

              <form onSubmit={formikAddress.handleSubmit}>
                <div className="form-floating mb-3">
                  <input
                    onChange={formikAddress.handleChange}
                    onBlur={formikAddress.handleBlur}
                    value={formikAddress.values.details}
                    name="details"
                    type="text"
                    className=" form-control"
                    id="details"
                  />
                  <label className="text-main" htmlFor="details">
                    Address Details:
                  </label>
                  {formikAddress.errors.details &&
                  formikAddress.touched.details ? (
                    <div className=" alert alert-danger">
                      {formikAddress.errors.details}
                    </div>
                  ) : null}
                </div>
                <div className="form-floating mb-3">
                  <input
                    onChange={formikAddress.handleChange}
                    onBlur={formikAddress.handleBlur}
                    value={formikAddress.values.city}
                    name="city"
                    type="text"
                    className=" form-control"
                    id="city"
                  />
                  <label className="text-main" htmlFor="city">
                    City:
                  </label>
                  {formikAddress.errors.city && formikAddress.touched.city ? (
                    <div className=" alert alert-danger">
                      {formikAddress.errors.city}
                    </div>
                  ) : null}
                </div>
                <div className="form-floating mb-3">
                  <input
                    onChange={formikAddress.handleChange}
                    onBlur={formikAddress.handleBlur}
                    value={formikAddress.values.phone}
                    name="phone"
                    type="tel"
                    className=" form-control"
                    id="phoneA"
                  />
                  <label className="text-main" htmlFor="phoneA">
                    Phone:
                  </label>
                  {formikAddress.errors.phone && formikAddress.touched.phone ? (
                    <div className=" alert alert-danger">
                      {formikAddress.errors.phone}
                    </div>
                  ) : null}
                </div>
                <div
                  style={{ display: "none" }}
                  className="alert alert-success doneAdd"
                >
                  Address added successfully
                </div>
                <div className="d-flex justify-content-between align-items-center">
                  {loadingAddress ? (
                    <button
                      className="btn bg-main text-white mt-1"
                      type="button"
                    >
                      {" "}
                      <i className="fa-solid fa-spinner fa-spin"></i>{" "}
                    </button>
                  ) : (
                    <button
                      disabled={!(formikAddress.isValid && formikAddress.dirty)}
                      className="btn bg-main text-white mt-1"
                      type="submit"
                      onClick={getAddress}
                    >
                      Submit
                    </button>
                  )}
                  {/* <button type='button' className='btn btn-outline-danger mt-1' onClick={()=> closeChangeForm('formAddress', 'change')}>Cancel</button> */}
                </div>
              </form>
            </div>
          )}
          <div
            style={{ display: "none" }}
            className="row shadow-lg rounded-bottom w-100 mx-auto py-3 pb-4 align-items-center formAddress"
          >
            <h2 className="text-main h4 mb-2">Add Address:</h2>

            <form onSubmit={formikAddress.handleSubmit}>
              <div className="form-floating mb-3">
                <input
                  onChange={formikAddress.handleChange}
                  onBlur={formikAddress.handleBlur}
                  value={formikAddress.values.details}
                  name="details"
                  type="text"
                  className=" form-control"
                  id="details"
                />
                <label className="text-main" htmlFor="details">
                  Address Details:
                </label>
                {formikAddress.errors.details &&
                formikAddress.touched.details ? (
                  <div className=" alert alert-danger">
                    {formikAddress.errors.details}
                  </div>
                ) : null}
              </div>
              <div className="form-floating mb-3">
                <input
                  onChange={formikAddress.handleChange}
                  onBlur={formikAddress.handleBlur}
                  value={formikAddress.values.city}
                  name="city"
                  type="text"
                  className=" form-control"
                  id="city"
                />
                <label className="text-main" htmlFor="city">
                  City:
                </label>
                {formikAddress.errors.city && formikAddress.touched.city ? (
                  <div className=" alert alert-danger">
                    {formikAddress.errors.city}
                  </div>
                ) : null}
              </div>
              <div className="form-floating mb-3">
                <input
                  onChange={formikAddress.handleChange}
                  onBlur={formikAddress.handleBlur}
                  value={formikAddress.values.phone}
                  name="phone"
                  type="tel"
                  className=" form-control"
                  id="phoneA"
                />
                <label className="text-main" htmlFor="phoneA">
                  Phone:
                </label>
                {formikAddress.errors.phone && formikAddress.touched.phone ? (
                  <div className=" alert alert-danger">
                    {formikAddress.errors.phone}
                  </div>
                ) : null}
              </div>
              <div
                style={{ display: "none" }}
                className="alert alert-success doneAdd"
              >
                Address added successfully
              </div>
              <div
                style={{ display: "none" }}
                className="alert alert-danger doneDelete"
              >
                Address removed successfully
              </div>
              <div className="d-flex justify-content-between align-items-center">
                {loadingAddress ? (
                  <button className="btn bg-main text-white mt-1" type="button">
                    {" "}
                    <i className="fa-solid fa-spinner fa-spin"></i>{" "}
                  </button>
                ) : (
                  <button
                    disabled={!(formikAddress.isValid && formikAddress.dirty)}
                    className="btn bg-main text-white mt-1"
                    type="submit"
                    onClick={getAddress}
                  >
                    Submit
                  </button>
                )}
                <button
                  type="button"
                  className="btn btn-outline-danger mt-1"
                  onClick={() => closeChangeForm("formAddress", "change")}
                >
                  Cancel
                </button>
              </div>
            </form>
          </div>
        </div>
        <hr />

        <div>
          <h2 className="text-main h4 mb-3">2- Payment Methods:</h2>

          {/* if Flag true => show Payment Methods */}
          {flag ? (
            <>
              <button onClick={payCash} className="btn Btn">
                Cash on Delivery <AttachMoneyIcon />
              </button>{" "}
              <button onClick={payOnline} className="ms-3 btn Btn">
                OnLine Payment <PaymentIcon />
              </button>
            </>
          ) : (
            ""
          )}
        </div>
      </div>
    </>
  );
}
